import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import { Home } from "./pages/Home";
import { About } from "./pages/About";
import { Conferences } from "./pages/Conferences";
import { ConferenceDetail } from "./pages/ConferenceDetail";
import { Books } from "./pages/Books";
import { BookDetail } from "./pages/BookDetail";
import { Trainings } from "./pages/Trainings";
import { TrainingDetail } from "./pages/TrainingDetail";
import { MoreLife } from "./pages/MoreLife";
import { Contact } from "./pages/Contact";
import { AdminLogin } from "./pages/AdminLogin";
import { EnhancedDashboard } from "./pages/admin/EnhancedDashboard";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import LiveChat from "./components/LiveChat";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";

// Layout wrapper for pages with header and footer
const Layout = ({ children }) => {
  return (
    <>
      <Navbar />
      {children}
      <Footer />
    </>
  );
};

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <Router>
          <ScrollToTop />
          <Routes>
            {/* Public Routes with Layout */}
            <Route path="/" element={<Layout><Home /></Layout>} />
            <Route path="/about" element={<Layout><About /></Layout>} />
            <Route path="/conferences" element={<Layout><Conferences /></Layout>} />
            <Route path="/conferences/:id" element={<Layout><ConferenceDetail /></Layout>} />
            <Route path="/books" element={<Layout><Books /></Layout>} />
            <Route path="/books/:id" element={<Layout><BookDetail /></Layout>} />
            <Route path="/trainings" element={<Layout><Trainings /></Layout>} />
            <Route path="/trainings/:id" element={<Layout><TrainingDetail /></Layout>} />
            <Route path="/morelife" element={<Layout><MoreLife /></Layout>} />
            <Route path="/contact" element={<Layout><Contact /></Layout>} />
            <Route path="/payment/success" element={<PaymentSuccessPage />} />
            
            {/* Admin Routes without Layout */}
            <Route path="/admin-login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<EnhancedDashboard />} />
          </Routes>
        </Router>
        <Toaster position="top-right" richColors />
        <LiveChat />
      </div>
    </AuthProvider>
  );
}

export default App;
